import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlanService } from 'src/app/services/actions/plan.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-plano',
  templateUrl: './plano.component.html',
  styleUrls: ['./plano.component.scss']
})
export class PlanoComponent implements OnInit {

  user = {}
  hasActivePlan = false
  hasPendingPlans = false
  hasPastPlans = false
  hasNoPlans = true
  showBuyCards = true
  showWaringnActivePlan = true
  userPlans
  typePlans = {}
  hasTypePlans = false
  planStatus = {
    ATIVO: 1,
    VENCIDO: 2,
    CANCELADO: 3,
    AGUARDANDO_PAGAMENTO: 4
  }

  constructor(
    private planService: PlanService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit () {
    this.user = this.userService.getUser()
    this.getTypePlans()
    this.getUserPlans(this.user['id'])
  }

  getUserPlans (userId) {
    this.planService
			.getUserPlans(userId)
			.subscribe(
				(res) => {
          if (res[0]) {
            this.hasNoPlans = false
            this.userPlans = res
            this.hasActivePlan = this.userPlans.filter((item) => { return item.status === this.planStatus.ATIVO })
            if (this.hasActivePlan[0] && this.hasActivePlan[0].recurrentPlanId) {
              this.hasTypePlans = false
            }
            if (this.hasActivePlan[0]) {
              this.showWaringnActivePlan = false
            }
            this.hasPendingPlans = this.userPlans.filter((item) => { return item.status === this.planStatus.AGUARDANDO_PAGAMENTO })
            this.hasPastPlans = this.userPlans.filter((item) => { return item.status === this.planStatus.VENCIDO || item.status === this.planStatus.CANCELADO })
          } else {
            this.showBuyCards = false
          }
				},
				(err) => {
					console.log(err);
				}
			);
  }

  getTypePlans () {
    this.planService
			.getTypePlans()
			.subscribe(
				(res) => {
          if (res['plans']) {
            this.typePlans = res
            this.hasTypePlans = true
          }
				},
				(err) => {
					console.log(err);
				}
			);
  }

  assinarPlano (planId) {
    this.router.navigateByUrl('/logado/carrinho-plano?plan_type=' + planId)
  }
}
